import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Table } from 'primeng/table';
import { Tasas } from '@p-p-portafolio/interfaces/tasas';
import { SwalService } from '@shared/utils/swal.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { TasasFormComponent } from './tasas-form/tasas-form.component';
import { TasasHistoricoComponent } from './tasas-historico/tasas-historico.component';
import Swal from 'sweetalert2';
import { MessageService } from 'primeng/api';

interface Column {
  field: string;
  header: string;
}

@Component({
  selector: 'app-tasas',
  templateUrl: './tasas.component.html',
  styleUrls: ['./tasas.component.css'],
  providers: [MessageService]
})
export class TasasComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayedColumns: Column[] = [
    { field: 'clave', header: 'Clave Tasa' },
    { field: 'fechaInicia', header: 'Fecha Inicial' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'valor', header: 'Valor' },
    { field: 'formula', header: 'Fórmula' },
    { field: 'actions', header: 'Acciones' }
  ];

  private readonly _width: string = '1000px';
  public allData: number = 0;
  public loading: boolean = true;
  public dataSource = {
    data: [] as Tasas[]
  };

  constructor(
    public _dialog: MatDialog,
    private _swalService: SwalService,
    private _tasasServices: TasasService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.read();
  }

  read() {
    this.loading = true;
    this._tasasServices.read().subscribe({
      next: (res) => {
        if (res.data) {
          this.dataSource.data = res.data;
          this.allData = res.data.length;
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar tasas:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los datos'
        });
        this.loading = false;
      }
    });
  }

  openHistorical(model: Tasas) {
    this._dialog.open(TasasHistoricoComponent, { 
      data: model,
      width: this._width
    });
  }

  openCreate() {
    const dialogRef = this._dialog.open(TasasFormComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.read();
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Tasa creada correctamente'
        });
      }
    });
  }

  openUpdate(model: Tasas) {
    const dialogRef = this._dialog.open(TasasFormComponent, {
      width: this._width,
      data: model,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.read();
        this.messageService.add({
          severity: 'success',
          summary: 'Éxito',
          detail: 'Tasa actualizada correctamente'
        });
      }
    });
  }

  delete(model: Tasas) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar la tasa ${model.clave}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this._tasasServices.delete(model).subscribe({
          next: (res) => {
            if (res.success || (res.data && res.data[0]?.error === "0")) {
              this.read();
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Tasa eliminada correctamente'
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: res.data[0]?.error || 'No se pudo eliminar la tasa'
              });
            }
            this.loading = false;
          },
          error: (err) => {
            console.error('Error al eliminar:', err);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: err.error?.message || 'Error al eliminar la tasa'
            });
            this.loading = false;
          }
        });
      }
    });
  }
}
